<template>
  <div class="default-box">
    <h2>お知らせ追加・編集</h2>
    <p class="back" @click="back()">← お知らせに戻る</p>
    <div class="info-box">
      <p class="input-title">日付</p>
      <div class="date-box">
        <input type="number" v-model.number="year" class="year-input" min="0" max="9999">
        <p>年</p>
        <input type="number" v-model.number="month" class="month-input" min="0" max="12">
        <p>月</p>
        <input type="number" v-model.number="date" class="date-input" min="0" max="31">
        <p>日</p>
      </div>
      <!-- <p class="input-info-date">{{ date_make(info_date) }}</p> -->
      <p class="input-title">タイトル</p>
      <input type="text" class="input-info-title" v-model="title">
      <p class="input-title">本文</p>
      <textarea class="input-info-content" v-model="content"/>
      <div v-if="info_id === 0" class="new-box">
        <input type="button" class="update_btn" @click="info_insert" value="保存" />
      </div>
      <div v-else class="edit-box">
        <input type="button" class="delete_btn" @click="info_delete" value="削除" />
        <input type="button" class="update_btn" @click="info_update" value="保存" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Default',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      info_id: 0,
      // info_date: '',
      title: '',
      content: '',
      year: '',
      month: '',
      date: ''
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    const date_obj = new Date();
    const year = String(date_obj.getFullYear());
    const month = ('00' + String(date_obj.getMonth()+1)).slice(-2);
    const date = ('00' + String(date_obj.getDate())).slice(-2);

    // this.info_date = year + month + date;

    let info_obj = this.$store.getters['Info/select_indo_data'];
    if (info_obj !== null) {
      // 編集
      this.info_id = info_obj.id;
      // this.info_date = info_obj.date;
      this.year = info_obj.date.substr(0, 4);
      this.month = info_obj.date.substr(4, 2);
      this.date = info_obj.date.substr(6, 2);
      this.title = info_obj.title;
      this.content = info_obj.content;
    } else {
      this.year = year;
      this.month = month;
      this.date = date;
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    date_make (date) {
      if (date === '') {
        return '';
      }
      return date.substr(0, 4) + '年' +
        date.substr(4, 2) + '月' +
        date.substr(6, 2) + '日';
    },
    back () {
      this.$router.back();
    },
    date_check() {
      let res_ymd = '';
      let pattern = /^\d+$/;
      if (
        pattern.test(this.year) === true &&
        pattern.test(this.month) === true &&
        pattern.test(this.date) === true
      ) {
        let res_year = ('0000' + String(this.year)).slice(-4);
        let res_month = ('00' + String(this.month)).slice(-2);
        let res_date = ('00' + String(this.date)).slice(-2);
        res_ymd = String(res_year) + String(res_month) + String(res_date);
      }
      return res_ymd;
    },
    info_insert () {
      let date_ymd = this.date_check();
      if (date_ymd === '') {
        this.$alert('alert', '日付を入力してください');
        return;
      }
      let ld = new this.$loader(this);
      ld._data_set({title: this.title, content: this.content, date: date_ymd});
      ld._post_cb_f = this.info_insert_cb;
      ld._load_start('/manage/information_add.php');
    },
    info_insert_cb (data) {
      if (data.res === 1) {
        this.$alert('alert', 'お知らせを追加しました。');
        this.$router.back();
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    info_update () {
      let date_ymd = this.date_check();
      if (date_ymd === '') {
        this.$alert('alert', '日付を入力してください');
        return;
      }
      let obj = {};
      obj.id = this.info_id;
      obj.date = date_ymd;
      obj.title = this.title;
      obj.content = this.content;

      let ld = new this.$loader(this);
      ld._data_set({information: obj});
      ld._post_cb_f = this.info_update_cb;
      ld._load_start('/manage/information_edit.php');
    },
    info_update_cb (data) {
      if (data.res === 1) {
        this.$alert('alert', 'お知らせを変更しました。');
        this.$router.back();
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    info_delete () {
      this.$alert('alert', 'このお知らせを削除しますか？', this.info_delete_start);
    },
    info_delete_start () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.info_id});
      ld._post_cb_f = this.info_delete_cb;
      ld._load_start('/manage/information_del.php');
    },
    info_delete_cb (data) {
      if (data.res === 1) {
        this.$alert('alert', 'お知らせを削除しました。');
        this.$router.back();
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.default-box {
  h2 {
    color: #6c5a57;
    text-align: left;
  }

  .info-box {
    padding: 10px;
    text-align: left;

    .date-box {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .year-input,
      .month-input,
      .date-input {
        width: 100px;
        text-align: right;
      }

      input[type="number"]::-webkit-outer-spin-button,
      input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      p {
        margin: 0 8px;
      }
    }

    .input-title {
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      font-size: 1.2rem;
      font-weight: bold;
      border-left: 6px solid #6c5a57;
    }

    .input-info-date {
      margin: 10px;
    }

    .input-info-title {
      margin: 10px;
      width: 600px;
    }

    .input-info-content {
      margin: 10px;
      height: 300px;
      width: 600px;
    }

    .new-box {
      width: 600px;
      display: flex;
      justify-content: center;
    }

    .edit-box {
      width: 600px;
      display: flex;
      justify-content: space-between;
    }

    .update_btn {
        color: #fefefe;
        display: block;
        text-align: center;
        padding: 8px;
        width: 200px;
        font-size: 16px;
        margin: 20px 0px 0px 0px;
        text-decoration: none;
        border-radius: 3px;
    }

    .delete_btn {
        color: #fefefe;
        background: #ef4747;
        display: block;
        text-align: center;
        padding: 8px;
        width: 200px;
        font-size: 16px;
        margin: 20px 0px 0px 0px;
        text-decoration: none;
        border-radius: 3px;
        &:hover {
          background: #ff6c6c;
        }
    }
  }

  .back {
      color: #00f;
      text-decoration: underline;
      text-align: left;
      font-size: 1.1rem;
      margin: 20px 0px 20px 0px;
      cursor: pointer;

      &:hover {
        color: #cd6c78;
      }
  }
}
</style>
